/**
 * Newsroom source of truth. Three arrays: NEWS, MEDIA, INSIGHTS.
 *
 * Editorial rules — do not undo:
 *   - The 13 Nov 2024 crowdfunding-platform clearance item is deliberately excluded.
 *   - Do NOT normalise historical bylines to a person's current title.
 *
 * Per-card schema (fields added 2026-10-30 for the dead-link pass):
 *   state                 "live" | "replaced" | "archived" | "unavailable"
 *                         - live: the original outlet URL is still reachable
 *                         - replaced: outlet URL was dead; url now points to a
 *                           surviving mirror of the same release, outlet NAME kept
 *                         - archived: original is dead; url is the verified
 *                           Wayback snapshot
 *                         - unavailable: no reachable copy exists; url removed
 *   label                 { en, zh } — rendered beneath the card for archived /
 *                         unavailable only; absent otherwise
 *   source_suffix         { en, zh } — appended to the outlet / source meta line;
 *                         only used for PR Newswire-origin cards
 *   archive_fallback_href Wayback URL kept as a hidden fallback for live cards.
 *                         Not rendered in the UI today — hiding against a future
 *                         dead-link flip.
 */

export const NEWS = [
  {
    date: "21 Feb 2025",
    headline:
      "Shaping the Future of the Singapore Equities Market \u2014 Frac's Co-Founder & Chairman Participates as a Panelist",
    source: "LinkedIn",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7298512998178951170/",
    state: "live",
    archive_fallback_href: null,
  },
  {
    date: "23 Oct 2024",
    headline: "Frac Announces Partnership with Traxx",
    source: "The Sun Malaysia",
    url: "https://thesun.my/business/jg-fiat-GP12950521/",
    state: "replaced",
    archive_fallback_href:
      "https://web.archive.org/web/20261030081111/https://thesun.my/business/jg-fiat-GP12950521/",
  },
  {
    date: "27 Sep 2024",
    headline:
      "Frac Co-Founders Discuss the Future of Asset Tokenization on XDC Network Podcast",
    source: "YouTube",
    url: "https://www.youtube.com/watch?v=AGfc6Xgcvik",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20250724121938/https://www.youtube.com/watch?v=AGfc6Xgcvik",
  },
  {
    date: "13 Sep 2024",
    headline:
      "Melvin Tan, Frac's Co-Founder & Chairman, Celebrates SIAS's 25th Anniversary",
    source: "LinkedIn",
    url: null,
    state: "unavailable",
    label: {
      en: "Original link no longer available",
      zh: "\u539F\u59CB\u94FE\u63A5\u5DF2\u5931\u6548",
    },
  },
  {
    date: "12 Sep 2024",
    headline:
      "Frac Joins ByBit's BGA Alliance, Pioneering Sustainable Fractional Ownership",
    source: "Blockchain for Good",
    url:
      "https://web.archive.org/web/20251211002733/https://blockchainforgood.xyz/news/detail/b0af9644-db28-4024-8e92-880999379c72",
    state: "archived",
    label: {
      en: "Original no longer online \u2014 archived copy",
      zh: "\u539F\u6587\u5DF2\u4E0B\u7EBF \u2014 \u5B58\u6863\u526F\u672C",
    },
  },
  {
    date: "14 Jun 2023",
    headline:
      "VeChain Technology Partners with Frac to Enhance Fractional Asset Trading with NFC Blockchain",
    source: "VeChain Foundation",
    url:
      "https://medium.com/vechain-foundation/vechain-technology-partners-with-frac-to-enhance-fractional-asset-trading-with-nfc-blockchain-b4c90e2f7aca",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20250123052448/https://medium.com/vechain-foundation/vechain-technology-partners-with-frac-to-enhance-fractional-asset-trading-with-nfc-blockchain-b4c90e2f7aca",
  },
];

export const MEDIA = [
  {
    date: "2025",
    outlet: "The Edge Malaysia",
    headline:
      "Bits + Bytes: A Miscellany of Technology (Gambit Group partnership)",
    url: "https://theedgemalaysia.com/node/714441",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20250725031445/https://theedgemalaysia.com/node/714441",
  },
  {
    date: "2024",
    outlet: "The Edge Malaysia",
    headline:
      "Frac's Mission Highlighted \u2014 tokenization of high-value assets",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7279377261110157313",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20251018094911/https://www.linkedin.com/feed/update/urn:li:activity:7279377261110157313",
  },
  {
    date: "2024",
    outlet: "Yahoo! Finance",
    headline: "Masverse Expands Ecosystem with Grant Recipient Frac",
    url:
      "https://web.archive.org/web/20241108030048/https://finance.yahoo.com/news/maschain-expands-ecosystem-grant-recipient-024800754.html",
    state: "archived",
    label: {
      en: "Original no longer online \u2014 archived copy",
      zh: "\u539F\u6587\u5DF2\u4E0B\u7EBF \u2014 \u5B58\u6863\u526F\u672C",
    },
    source_suffix: {
      en: " via PR Newswire",
      zh: " \u7ECF PR Newswire \u53D1\u5E03",
    },
  },
  {
    date: "2024",
    outlet: "Vulcan Post",
    headline:
      "Frac Secures Funding Boost from Masverse to Propel Blockchain-Based Tokenization",
    url:
      "https://prnewswire.com/apac/news-releases/maschain-expands-ecosystem-with-new-grant-recipient-frac-302299559.html",
    state: "replaced",
    archive_fallback_href:
      "https://web.archive.org/web/20241108030059/https://www.prnewswire.com/apac/news-releases/maschain-expands-ecosystem-with-new-grant-recipient-frac-302299559.html",
    source_suffix: {
      en: " via PR Newswire",
      zh: " \u7ECF PR Newswire \u53D1\u5E03",
    },
  },
  {
    date: "2024",
    outlet: "AsiaBizToday",
    headline:
      "Frac Secures Masverse Grant to Accelerate Digital Asset Tokenization",
    url:
      "https://manilatimes.net/2024/11/08/tmt-newswire/pr-newswire/maschain-expands-ecosystem-with-new-grant-recipient-frac/2000338",
    state: "replaced",
    archive_fallback_href: null,
    source_suffix: {
      en: " via PR Newswire",
      zh: " \u7ECF PR Newswire \u53D1\u5E03",
    },
  },
  {
    date: "2024",
    outlet: "Blockhead",
    headline:
      "Frac Gains Momentum with Masverse Grant to Enhance Blockchain Tokenization",
    url: null,
    state: "unavailable",
    label: {
      en: "Original link no longer available",
      zh: "\u539F\u59CB\u94FE\u63A5\u5DF2\u5931\u6548",
    },
    source_suffix: {
      en: " via PR Newswire",
      zh: " \u7ECF PR Newswire \u53D1\u5E03",
    },
  },
  {
    date: "2024",
    outlet: "Taiwan News",
    headline: "Frac Joins MasChain Ecosystem with Strategic Grant Award",
    url: "https://taiwannews.com.tw/news/5967475",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20260519012859/https://www.taiwannews.com.tw/news/5967475",
    source_suffix: {
      en: " via PR Newswire",
      zh: " \u7ECF PR Newswire \u53D1\u5E03",
    },
  },
  {
    date: "2024",
    outlet: "The Sun Malaysia",
    headline:
      "FRAC, Singapore's Traxx ink MoU to lead fiat-to-digital payment integration",
    url: "https://thesun.my/business/jg-fiat-GP12950521/",
    state: "replaced",
    archive_fallback_href:
      "https://web.archive.org/web/20261030081111/https://thesun.my/business/jg-fiat-GP12950521/",
  },
  {
    date: "2024",
    outlet: "Focus Malaysia",
    headline:
      "FRAC and GamBit ink strategic collaboration MOU to empower the future of asset management",
    url:
      "https://focusmalaysia.my/frac-and-gambit-ink-strategic-collaboration-mou-to-empower-the-future-of-asset-management/",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20251007124853/https://focusmalaysia.my/frac-and-gambit-ink-strategic-collaboration-mou-to-empower-the-future-of-asset-management/",
  },
  {
    date: "2023",
    outlet: "The Star Malaysia",
    headline: "A better year ahead for crypto investors?",
    url:
      "https://www.thestar.com.my/business/business-news/2023/01/25/a-better-year-ahead-for-crypto-investors",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20261030081422/https://www.thestar.com.my/business/business-news/2023/01/25/a-better-year-ahead-for-crypto-investors",
  },
];

export const INSIGHTS = [
  {
    title:
      "Frac Pioneered PayFi Before It Had a Name \u2014 Here's Why It Matters",
    author: "Melvin Tan, Co-Founder & Chairman",
    url:
      "https://www.linkedin.com/pulse/frac-pioneered-payfi-before-had-nameheres-why-matters-melvin-uhwxc",
    state: "live",
    archive_fallback_href: null,
  },
  {
    title: "My Inspiration for Starting Frac",
    author: "Japhet Lim, Co-Founder & CEO",
    url:
      "https://www.linkedin.com/pulse/my-inspiration-starting-frac-japhet-lim--cfbzc",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20250803024743/https://www.linkedin.com/pulse/my-inspiration-starting-frac-japhet-lim--cfbzc",
  },
  {
    title:
      "Your Fractional Sunday with Frac: Blockchain's Bright Future",
    author: "Office of the Chairman",
    url:
      "https://www.linkedin.com/pulse/your-fractional-sunday-frac-dawn-new-era-blockchain-tokenization-of7vc",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20241124022822/https://www.linkedin.com/pulse/your-fractional-sunday-frac-dawn-new-era-blockchain-tokenization-of7vc",
  },
  {
    title:
      "How Tokenization Can Empower Small Nations: Lessons from Malta",
    author: "Melvin Tan, Co-Founder & Chairman",
    url:
      "https://www.linkedin.com/pulse/how-tokenization-can-empower-small-nations-lessons-melvin-9ndhc/",
    state: "live",
    archive_fallback_href:
      "https://web.archive.org/web/20241120070510/https://www.linkedin.com/pulse/how-tokenization-can-empower-small-nations-lessons-melvin-9ndhc/",
  },
  {
    // Operator will supply article text to republish on frac.io.
    title: "Unlocking Financial Access for the Unbanked in ASEAN",
    author: "Melvin Tan, Co-Founder & Chairman",
    url: null,
    state: "unavailable",
    label: {
      en: "Original link no longer available",
      zh: "\u539F\u59CB\u94FE\u63A5\u5DF2\u5931\u6548",
    },
  },
  {
    title: "Tokenization for Consumers vs Tokenization for Investors",
    author: "Japhet Lim, Co-Founder & CEO",
    url:
      "https://www.linkedin.com/pulse/tokenisation-consumers-vs-investors-japhet-lim--lrtec",
    state: "live",
    archive_fallback_href: null,
  },
];
